import { render, staticRenderFns } from "./LoginSelectTenant.vue?vue&type=template&id=736efaf6&scoped=true&"
import script from "./LoginSelectTenant.vue?vue&type=script&lang=js&"
export * from "./LoginSelectTenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736efaf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('736efaf6')) {
      api.createRecord('736efaf6', component.options)
    } else {
      api.reload('736efaf6', component.options)
    }
    module.hot.accept("./LoginSelectTenant.vue?vue&type=template&id=736efaf6&scoped=true&", function () {
      api.rerender('736efaf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/LoginSelectTenant.vue"
export default component.exports